import { useEffect, useState } from 'react'
import { SearchBarButton } from './SearchBarButton'
import { SearchPopup } from './SearchPopup'
import { useDiRef } from '@/common/react/di-hooks'
import type { HotkeysService } from '@/core/hotkeys/HotkeysService'

export function SearchBar() {
  const [open, setOpen] = useState(false)
  const hotkeysService = useDiRef<HotkeysService>('HotkeysService')

  useEffect(() => {
    const sub = hotkeysService.on('openSearch').subscribe(() => setOpen(true))
    return () => sub.unsubscribe()
  }, [hotkeysService])

  return (
    <>
      <SearchBarButton onClick={() => setOpen(true)} />
      <SearchPopup open={open} onClose={() => setOpen(false)} />
    </>
  )
}
